import { DefaultTheme } from "styled-components";

export const getSnaccDimensions = (isSnaccStorefrontV2: boolean) => {
    return {
        container: {
            width: isSnaccStorefrontV2 ? "90px" : "95px",
            height: isSnaccStorefrontV2 ? "194px" : "150px", // 186px + 8px (paddingTop) = 194px
        },
        image: {
            width: isSnaccStorefrontV2 ? "90px" : "95px",
            height: isSnaccStorefrontV2 ? "133px" : "92px",
        },
    };
};

export const CrossSellM2ItemConfig = (theme: DefaultTheme, isPopCart = false, isSnaccStorefrontV2 = false) => {
    const { width: snaccContainerWidth, height: snaccContainerHeight } =
        getSnaccDimensions(isSnaccStorefrontV2).container;
    const { width: snaccImageWidth, height: snaccImageHeight } = getSnaccDimensions(isSnaccStorefrontV2).image;

    return {
        container: {
            width: isPopCart ? snaccContainerWidth : "75px",
            height: isPopCart ? snaccContainerHeight : "130px",
            margin: `${theme.spacing.xxSmall} ${theme.spacing.small} 0 0`,
        },
        textContainerWidth: "100%",
        textContainerPadding: `0px ${theme.spacing.xxxSmall}`,
        imageContainer: {
            width: isPopCart ? snaccImageWidth : "75px",
            height: isPopCart ? snaccImageHeight : "72px",
        },
        addItemContainer: {
            top: `calc(${theme.spacing.xxxSmall} * -1)`,
            right: `calc(${theme.spacing.xxSmall} * -1)`,
        },
        name: {
            width: isPopCart ? "84px" : "64px",
        },
    };
};
